import Button from "shared/components/Button";
import { useAppDispatch, useAppSelector } from "app/hooks";
import { setLayerVisibility } from "features/krpano/details-slice";

interface ShowHideFieldsProps {}

export const ShowHideFields: React.FC<ShowHideFieldsProps> = () => {
  const fieldLayers = useAppSelector((state) => state.krpano.layers.fields);
  const showFields = fieldLayers.every((layer) => layer.visible);

  const dispatch = useAppDispatch();
  const handleSetShowHideFields = () =>
    dispatch(setLayerVisibility([{ type: "fields", visible: !showFields }]));

  return (
    <Button
      colour="ThemeAlt"
      additionalClassNames="BtnLink"
      onClick={handleSetShowHideFields}
    >
      {showFields ? "Hide" : "Show"} Fields
    </Button>
  );
};
